// src/features/trackingSlice.ts

import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShipmentTrackingRequest } from '../../api/request_type/ShipmentTrackingRequest';
import { Companyinformation, Driverinfo, Driverlocation, Etadata, ShipmentTrackingResponse, Trackingaddress, Trackingdata, Trackinginfo } from '../../api/response_type/ShipmentTrackingResponse';
import { GetEtaForTrackingRequest } from '../../api/request_type/GetEtaForTrackingRequest';
import { GetEtaForTrackingResponse } from '../../api/response_type/GetEtaForTrackingResponse';
import { DownloadPodRequest } from '../../api/request_type/DownloadPodRequest';
import { DownloadPodResponse } from '../../api/response_type/DownloadPodResponse';
import ShipmentTrackingApi from '../../api/ShipmentTrackingApi';
import { ThemeCssRequest } from '../../api/request_type/ThemeCssRequest';
import { ThemeCssResponse } from '../../api/response_type/ThemeCssResponse';
import { ShipmentTokenRequest } from '../../api/request_type/ShipmentTokenRequest';
import { ShipmentTokenResponse } from '../../api/response_type/ShipmentTokenResponse';
import { withHostBrand } from '../../tracking/trackingSettings';

interface TrackingState {
  trackingNum: string;
  status: string | null;
  isLoading: boolean;
  companyinfo: Companyinformation;
  trackingAddress: Trackinginfo;
  etaData: Record<string, Etadata>;
  trackingdata: Record<string, Trackingdata[]>;
  getEta: any | null;
  getEtaDate: any | null;
  getEtaTime: any | null;
  getEtaMonth: any | null;
  userPostCode: string;
  downloadPod: string;
  trackingstatus: string | null;
  deliverydate: any | null;
  isinternal: number | null;
  shipmentType: string | null;
  SearchByLoadIdentity: boolean;
  loadIdentity:string;
  images:any |null;
  etaDetailsLoaded:boolean;
  driverlocation:Driverinfo[];
  driverInfo:Driverlocation;
  total_drops:Trackinginfo;
  currentStatus:any;
  statusList:any;
  themecss:ThemeCssResponse; 
  // BR-1920: the API decides what a visitor may see. true = it sent the full record (verified postcode /
  // phone digits, or a tracking link token); false = status and events only.
  fullAccess:boolean;
  // BR-1929: the customer's own reference (ref1). The API blanks it until the visitor verifies (BR-1881);
  // shown only for companies whose action_on_tracking lists 'show_reference'.
  customerRef:string;
}

const initialState: TrackingState = {
  trackingNum: '',
  status: null,
  isLoading: false,
  companyinfo: {} as Companyinformation,
  trackingAddress: {} as Trackinginfo,
  etaData: {} as Record<string, Etadata>,
  trackingdata: {} as Record<string, Trackingdata[]>,
  getEta: null,
  getEtaDate: null,
  getEtaTime: null,
  getEtaMonth: null,
  userPostCode: '',
  downloadPod: '',
  trackingstatus: null,
  deliverydate: null,
  isinternal: null,
  shipmentType: null,
  SearchByLoadIdentity: false,
  loadIdentity:'',
  images:[],
  etaDetailsLoaded:false,
  driverlocation:[] as Driverinfo[],
  driverInfo:{} as Driverlocation,
  total_drops: {} as Trackinginfo,
  currentStatus: [],
  statusList:[],
  themecss: {} as ThemeCssResponse,
  fullAccess: false,
  customerRef: '',
};
export const ShipmentTrackingActionThunk = createAsyncThunk(
  'ShipmentTrackingActionThunk',
  async (payload: ShipmentTrackingRequest): Promise<ShipmentTrackingResponse> => {
    let api = new ShipmentTrackingApi();
    // console.log(api);
    return api.ShipmentTrackingAction(payload);
  },
);
export const ShipmentTokenActionThunk = createAsyncThunk(
  'ShipmentTokenActionThunk',
  async (payload: ShipmentTokenRequest): Promise<ShipmentTokenResponse> => {
    let api = new ShipmentTrackingApi();
    // console.log(api);
    return api.ShipmentTokenAction(payload);
  },
);
export const EtaForTrackingThunk = createAsyncThunk(
  'EtaForTrackingThunk',
  async (payload: GetEtaForTrackingRequest): Promise<GetEtaForTrackingResponse> => {
    let api = new ShipmentTrackingApi();
    return api.GetEtaForTracking(payload);
  },
);
export const DownloadPodThunk = createAsyncThunk(
  'DownloadPodThunk',
  async (payload: DownloadPodRequest): Promise<DownloadPodResponse> => {
    let api = new ShipmentTrackingApi();
   // console.log(api);
    return api.DownloadPodAction(payload);
  },
);
export const GetThemeCssThunk = createAsyncThunk(
  'GetThemeCssThunk',
  async (payload: ThemeCssRequest): Promise<ThemeCssResponse> => {
    let api = new ShipmentTrackingApi();
    return api.GetThemeCss(payload);
  },
);
const TrackingSlice = createSlice({
  name: 'TrackingSlice',
  initialState,
  reducers: {
    resetPodData:state =>{
      state.downloadPod = '';
      // state.trackingAddress = {};
    },
    resetTrackingNum:state =>{
      state.trackingNum = '';
    },

    resetPostcode:state =>{
      state.userPostCode = '';
    },
    resetImages:state =>{
      state.trackingdata = {};
      state.customerRef = '';
      state.deliverydate = null;
      state.getEtaDate = null;
    },
    resetdriverInfo:state =>{
      state.driverlocation = [];
    },
    setImages(state, action: PayloadAction<string>) {
      state.images = action.payload;
    },
    setcurrentStatus(state, action: PayloadAction<string>) {
      state.currentStatus = action.payload;
    },
    resetstatusList(state, action: PayloadAction<string>) {
      state.statusList = action.payload;
    },
    setTrackingNum(state, action: PayloadAction<string>) {
      state.trackingNum = action.payload;
    },
    setUserPostCode(state, action: PayloadAction<string>) {
      state.userPostCode = action.payload;
    },
    setloadIdentity(state, action: PayloadAction<string>) {
      state.loadIdentity = action.payload;
    },
    setEtaDetailsLoaded:(state,action:PayloadAction<boolean>)=>{
      state.etaDetailsLoaded=action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(ShipmentTrackingActionThunk.pending, (state, action) => {
      state.isLoading = true;

    });
    builder.addCase(ShipmentTrackingActionThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      if (action.payload.status === 'success') {
        state.companyinfo = withHostBrand(action.payload.company_information);   // BR-2011: brand by tracking domain
        state.trackingAddress = action.payload.tracking_info;
        state.etaData = action.payload.eta_data;
        state.trackingdata = action.payload.trackingdata;
        state.trackingstatus = action.payload.status;
        state.isinternal = action.payload.is_internal;
        state.shipmentType = action.payload.shipment_type;
        state.SearchByLoadIdentity = action.payload.isSearchFromLoadIdentity;
        state.driverlocation = action.payload.driver_info;
        state.driverInfo = action.payload.tracking_info.driver_location;
        state.total_drops = action.payload.tracking_info;
        state.statusList = action.payload.trackingdata;
        state.etaDetailsLoaded=true;
        state.fullAccess = action.payload.restricted !== true;
        state.customerRef = String(action.payload.ref1 ?? '');
      }
       else {
        state.fullAccess = false;
        state.customerRef = '';
        const identity = String(action.meta.arg?.identity ?? '').trim();
        const origin = String(action.meta.arg?.origin ?? '');
        const errorCode = (action.payload as any)?.error_code;
        const suppressError = errorCode === 'ERROR003' && origin === 'tracking';
        if (identity !== '' && !suppressError) {
          alert(action.payload.message);
        }
      }
    });
    builder.addCase(ShipmentTrackingActionThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(EtaForTrackingThunk.pending, (state, action) => {
      state.isLoading = true;

    });
    builder.addCase(EtaForTrackingThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      // if(action.payload.status){
      state.getEtaMonth = action.payload.month;
      state.getEtaDate = action.payload.day;
      state.getEtaTime = action.payload.year;
      state.getEta = action.payload.eta;
      state.deliverydate = action.payload.delivery_date;
      // }else{
      //   alert("ETA Not Found");
      // }
    });
    builder.addCase(EtaForTrackingThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(DownloadPodThunk.pending, (state, action) => {
      state.isLoading = true;

    });
    builder.addCase(DownloadPodThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      if (action.payload.status === 'success') {
        state.downloadPod = action.payload.pod_path;
        state.loadIdentity = action.payload.load_identity;
      } 
    });
    builder.addCase(DownloadPodThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(GetThemeCssThunk.pending, (state, action) => {
      state.isLoading = true;

    });
    builder.addCase(GetThemeCssThunk.fulfilled, (state, action) => {
      state.isLoading = false;
        state.themecss = action.payload;

    });
    builder.addCase(GetThemeCssThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
     builder.addCase(ShipmentTokenActionThunk.pending, (state, action) => {
      state.isLoading = true;

    });
    builder.addCase(ShipmentTokenActionThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      if (action.payload.status === 'success') {
        state.companyinfo = withHostBrand(action.payload.company_information);   // BR-2011: brand by tracking domain
        state.trackingAddress = action.payload.tracking_info;
        state.etaData = action.payload.eta_data;
        state.trackingdata = action.payload.trackingdata;
        state.trackingstatus = action.payload.status;
        state.isinternal = action.payload.is_internal;
        state.shipmentType = action.payload.shipment_type;
        state.SearchByLoadIdentity = action.payload.isSearchFromLoadIdentity;
        state.driverlocation = action.payload.driver_info;
        state.driverInfo = action.payload.tracking_info.driver_location;
        state.total_drops = action.payload.tracking_info;
        state.statusList = action.payload.trackingdata;
        state.etaDetailsLoaded=true;
        state.fullAccess = action.payload.restricted !== true;
        state.customerRef = String(action.payload.ref1 ?? '');
        if (action.payload.shipment_ticket) {
          state.trackingNum = action.payload.shipment_ticket;
        }
        const trackingAddresses = action.payload.tracking_info?.tracking_address;
        if (Array.isArray(trackingAddresses)) {
          const targetTicket = action.payload.shipment_ticket;
          const matched =
            trackingAddresses.find(
              t => t.shipment_ticket == targetTicket && t.shipment_service_type == 'D',
            ) || trackingAddresses.find(t => t.shipment_ticket == targetTicket);
          if (matched?.post_code) {
            state.userPostCode = matched.post_code;
          }
        }
      }
       else {
        const token = String(action.meta.arg?.token ?? '').trim();
        const origin = String(action.meta.arg?.origin ?? '');
        const errorCode = (action.payload as any)?.error_code;
        const suppressError = errorCode === 'ERROR003' && origin === 'tracking';
        if (token !== '' && !suppressError) {
          alert(action.payload.message);
        }
      }
    });
    builder.addCase(ShipmentTokenActionThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
  }
});

export const { setTrackingNum, setUserPostCode ,resetPodData,setImages,setcurrentStatus,resetstatusList,resetdriverInfo,
  setloadIdentity,resetTrackingNum,resetPostcode,resetImages,setEtaDetailsLoaded} = TrackingSlice.actions;

export default TrackingSlice.reducer;
